const WORKLOCATIONS_TABLE_READY = "workLocations-table-ready"
const SEARCH_TEXT_STATE = "workLocations-table-search-text-state"
const ROWS_PER_PAGE_STATE = "workLocations-table-rows-per-page-state"
const PAGINATION_STATE = "workLocations-table-pagination-state"

const WORKLOCATIONS_ID_FOR_ACTION = "workLocations-table-brand-id-for-action"


const ADDEDIT_WORKLOCATIONS_READY = "workLocations-table-addedit-workLocations-ready"

const initialState = {
    isWorkLocationsTableReady: true,
    isAddEditWorkLocationsReady: true,
    workLocations: {},

    
    workLocationsSelectedId: null,
    
    previousSearchText: "",
    previousRowsPerPageValue: 15,
    previousPaginationValue: 1,
    
}


export default function reducer(state = initialState, action) {
    let duplicateState = null
    switch (action.type) {
        case WORKLOCATIONS_TABLE_READY:
            return Object.assign({}, state, { isWorkLocationsTableReady: action.payload })

        case ADDEDIT_WORKLOCATIONS_READY:
            return Object.assign({}, state, { isAddEditWorkLocationsReady: action.payload })

            
        
        case SEARCH_TEXT_STATE :
            duplicateState = Object.assign({}, state)
            duplicateState.previousSearchFieldText = action.payload
            return Object.assign({}, state, duplicateState)
        
        case ROWS_PER_PAGE_STATE:
            duplicateState=Object.assign({},state)
            duplicateState.previousRowsPerPageValue= action.payload
            return Object.assign({}, state, duplicateState)
        
        case PAGINATION_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)

        case WORKLOCATIONS_ID_FOR_ACTION:
            return Object.assign({}, state, {workLocationsSelectedId:action.payload})

        default:
        return state
    
    }

}

export function workLocationsTableReady(data) {
    return {
        type: WORKLOCATIONS_TABLE_READY,
        payload: data
    }
}

export function addEditWorkLocationsReady(data) {
    return {
        type: ADDEDIT_WORKLOCATIONS_READY,
        payload: data
    }
}



export function searchTextState(searchText){
    return {
        type:SEARCH_TEXT_STATE,
        payload:searchText
    }
}

export function rowsPerPageState(rows){
    return {
        type:ROWS_PER_PAGE_STATE,
        payload:rows
    }
}

export function paginationState(pageNo){
    return{
        type:PAGINATION_STATE,
        payload:pageNo
    }
}

export function workLocationsIdForAction(workLocationsId){
    return{
        type:WORKLOCATIONS_ID_FOR_ACTION,
        payload:workLocationsId
    }
}


// WEBPACK FOOTER //
// ./src/modules/Work Locations/redux/workLocations.js